module.exports = __webpack_public_path__ + "img/averageTooth.785b4c11.png";